<div
  class="c02-remote-control-buttons on-{{ featureName.toLowerCase() }}"
  (mouseenter)="onComponentMouseEnter()"
  (mouseleave)="onComponentMouseLeave()"
  (focusin)="onComponentMouseEnter()"
  (focusout)="onComponentMouseLeave()"
  [ngClass]="{ abstract: isAbstractVersion }"
>
  <div class="remote-inner-wrapper" data-animation="remote-enter-wrapper">
    <ng-container *ngIf="!isAbstractVersion; else abstractRemote">
      <img
        class="remote-asset visible"
        src="{{ '/assets/images/google-remote/remote-control.png' | assetpipe }}"
        alt="Remote control"
      />
      <img
        *ngFor="let button of directionalButtons; trackBy: identify"
        data-animation="control-button-highlights"
        class="remote-asset button asset-{{ button.key }}"
        [ngClass]="{ visible: button.isActive }"
        src="{{ baseHref }}/assets/images/google-remote/google-remote-{{ button.key }}.png"
        alt=""
      />
    </ng-container>
    <ng-template #abstractRemote>
      <img class="remote-asset visible" [src]="remoteImageSrc" alt="Remote control" />
      <img
        *ngFor="let button of directionalButtons; trackBy: identify"
        data-animation="control-button-highlights-abstract"
        class="remote-asset abstract-highlight button asset-{{ button.key }}"
        [ngClass]="{ visible: button.isActive }"
        src="{{ baseHref }}/assets/images/abstract-remote/abstract-remote-{{ button.key }}.png"
        alt=""
      />
    </ng-template>
    <div class="buttons-wrapper">
      <button
        #controlButtonsRef
        *ngFor="let button of directionalButtons; trackBy: identify"
        [attr.data-direction]="button.key"
        class="wheel-button"
        (mouseover)="onButtonMouseOver($event)"
        (mouseleave)="onButtonMouseLeave()"
        (blur)="onButtonMouseLeave()"
        (focus)="onButtonMouseOver($event)"
        (click)="onButtonClick(button.key)"
        [disabled]="!button.isActive || disabled"
        [attr.aria-disabled]="!button.isActive || disabled"
        [attr.aria-label]="button.ariaLabel"
        aria-describedby="tooltip-copy"
      ></button>
    </div>

    <div class="voice-button" *ngIf="isSttEnabled && showVoiceButton">
      <app-speech-button></app-speech-button>
    </div>

    <div class="tooltip-position-wrapper" *ngIf="tooltipCopy" [ngClass]="tooltipClassName">
      <div class="remote-control-tooltip">
        <p id="tooltip-copy" class="tooltip-copy" [innerHTML]="tooltipCopy"></p>
      </div>
    </div>
  </div>
</div>
